import _Refresh from "@mui/icons-material/Refresh";
import React from 'react';
import { IconButton } from '@mui/material';
import { useNative } from 'app/contexts/NativeContext';
import isGreaterSemVersionThan from './isGreaterSemVersionThan';
const pullToRefreshVersion = '3.7.1';
const NativeRefreshButton = _ref => {
  let {
    onClick
  } = _ref;
  const {
    isNativeApp,
    buildInfo
  } = useNative();
  if (!isNativeApp) {
    return null;
  }
  const isMinSupportedVersion = isGreaterSemVersionThan(buildInfo === null || buildInfo === void 0 ? void 0 : buildInfo.version, pullToRefreshVersion);
  if (isMinSupportedVersion) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClick,
    size: "large",
    "data-sentry-element": "IconButton",
    "data-sentry-component": "NativeRefreshButton",
    "data-sentry-source-file": "NativeRefreshButton.tsx"
  }, /*#__PURE__*/React.createElement(_Refresh, {
    color: "action",
    "data-sentry-element": "Refresh",
    "data-sentry-source-file": "NativeRefreshButton.tsx"
  }));
};
export default NativeRefreshButton;